import { createPinia, PiniaPluginContext } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import { parse, stringify } from 'zipson';

import { apiClient } from '@/plugins/api-client';

export const apiClientPlugin = ({ store }: PiniaPluginContext) => {
  store.$apiClient = apiClient;
};

export const piniaInstance = createPinia();
piniaInstance.use(
  createPersistedState({
    serializer: {
      deserialize: parse,
      serialize: stringify,
    },
  }),
);

piniaInstance.use(apiClientPlugin);
